<template>
    <div v-if="loaded" class="nevs-content">
        <div class="nevs-content-top-buttons">
            <NevsButton class="success" @click="saveClick()">
                <i class="fa-solid fa-floppy-disk"></i>
                {{ $LANG.Get('buttons.save') }}
            </NevsButton>&nbsp;
            <NevsButton class="error" @click="backClick">
                <i class="fa-solid fa-arrow-left"></i>
                {{ $LANG.Get('buttons.back') }}
            </NevsButton>
        </div>
        <NevsCard class="form">
            <NevsTextField v-model="membership.name" :error="membershipValidation.name"
                           :label="'*' + $LANG.Get('fields.name') + ':'"></NevsTextField>
            <NevsTextField v-model="membership.duration" :error="membershipValidation.duration"
                           :label="'*' + $LANG.Get('fields.durationMonths') + ':'"></NevsTextField>
            <NevsNumberField v-model="membership.price" :error="membershipValidation.price"
                             :label="$LANG.Get('fields.price') + ':'"></NevsNumberField>
        </NevsCard>
    </div>
</template>

<script>
import Membership from '@/models/Membership.js';
import NevsCard from "@/components/nevs/NevsCard.vue";
import NevsTextField from "@/components/nevs/NevsTextField.vue";
import NevsNumberField from "@/components/nevs/NevsNumberField.vue";
import NevsButton from "@/components/nevs/NevsButton.vue";

export default {
    name: "EntityMembership",
    components: {NevsButton, NevsNumberField, NevsTextField, NevsCard},
    data() {
        return {
            loaded: false,
            mode: this.$route.params.id === '0' ? 'add' : 'edit',
            membership: new Membership({id: this.$route.params.id}),
            membershipValidation: new Membership({}, true)
        }
    },
    methods: {
        backClick() {
            if (window.history.length === 1) {
                window.close();
            } else {
                this.$router.back();
            }
        },
        saveClick() {
            let valid = true;

            if (this.membership.name === '') {
                valid = false;
                this.membershipValidation.name = this.$LANG.Get('labels.mandatoryField');
            } else {
                this.membershipValidation.name = '';
            }

            let duration = parseInt(this.membership.duration);
            if (isNaN(duration) || duration <= 0) {
                valid = false;
                this.membershipValidation.duration = this.$LANG.Get('labels.durationInvalid');
            } else {
                this.membershipValidation.duration = '';
                this.membership.duration = duration;
            }

            if (this.membership.price < 0) {
                valid = false;
                this.membershipValidation.price = this.$LANG.Get('labels.errorNegativeValue');
            } else {
                this.membershipValidation.price = '';
            }

            if (valid) {
                let vm = this;
                let requestMethod = this.mode === 'add' ? 'post' : 'put';
                let requestService = this.mode === 'add' ? 'memberships' : 'memberships/' + this.membership.id;
                this.$API.APICall(requestMethod, requestService, this.membership, (data, success) => {
                    if (success) {
                        vm.$CROSS_TAB_BUS.TriggerEvent('reload-memberships', {});
                        vm.$LOCAL_BUS.TriggerEvent('notification', {text: vm.$LANG.Get('alerts.recordSaved')});
                        vm.backClick();
                    } else {
                        vm.$HELPERS.HandleServerError(vm, data);
                    }
                });
            }
        }
    },
    mounted() {
        this.$store.commit('setHelpOverlay', []);
        this.$store.commit('selectMenu', 'memberships');

        if (this.mode === 'add') {
            this.$store.commit('setBreadcrumbs', [
                {
                    label: this.$LANG.Get('modules.memberships'),
                    link: '/memberships'
                },
                {
                    label: this.$LANG.Get('modules.newMembership'),
                    link: null
                }
            ]);
            this.loaded = true;
        } else {
            let vm = this;
            this.$API.APICall('get', 'memberships/' + this.membership.id, {}, (data, success) => {
                if (success && data.membership !== null) {
                    vm.membership.Fill(data.membership);
                    vm.$store.commit('setBreadcrumbs', [
                        {
                            label: vm.$LANG.Get('modules.memberships'),
                            link: '/memberships'
                        },
                        {
                            label: vm.membership.name,
                            link: null
                        }
                    ]);
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
                vm.$nextTick(() => {
                    vm.loaded = true;
                });
            });
        }
    }
}
</script>

<style scoped>
.form {
    max-width: 350px;
    margin-bottom: 10px;
    padding: 15px;
}
</style>
